// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const InputFileDataCorrection = lazy(
  () => import('pages/dataCorrection/dataCorrection')
);
const InputFileUploadRoute = (
  <Route path={routeName.inputFileDataCorrection}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.UPLOAD_DOWNLOAD_INPUT_FILES}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <InputFileDataCorrection type="input" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default InputFileUploadRoute;
